/* ════════════════════════════════════════════════════════════════════
   즉시 구매(Buy Now) — 담고 바로 체크아웃

   카페24 영문몰(skin148)의 `product_submit(1, …)` 대응. 그쪽은 장바구니를 거치지 않고
   주문서로 직행하는데, Shopify 는 결제 전에 장바구니가 있어야 하므로
   **담은 뒤 체크아웃으로 보낸다**(고객이 보는 결과는 같다).

   ⚠️ Dawn 의 `<product-form>` 이 폼 submit 을 가로채 `/cart/add.js` 로 보낸다. 그래서
      `return_to` hidden 필드를 넣는 흔한 방법이 **무시된다**. 버튼을 `type="button"` 으로 두고
      여기서 직접 담고 이동한다.
   ⚠️ 폼 데이터를 그대로 보낸다 — variant id·수량·판매 옵션이 이미 들어 있어
      Add to Cart 와 **같은 것이 담긴다**. 값을 따로 조립하면 둘이 조용히 갈린다.
   ════════════════════════════════════════════════════════════════════ */
(() => {
  "use strict";

  /* Shopify 가 심는 경로. 로케일 프리픽스(예: /en-kr)가 붙는 스토어에서도 맞다 —
     ⚠️ '/cart/add' 를 손으로 쓰지 말 것. 다국어 스토어에서 404 가 된다. */
  const routes = window.routes || {};
  const ADD_URL = (routes.cart_add_url || "/cart/add") + ".js";
  const CHECKOUT_URL = "/checkout";

  const setBusy = (btn, on) => {
    btn.classList.toggle("loading", on);
    btn.disabled = on;
    const spinner = btn.querySelector(".loading__spinner, .loading-overlay__spinner");
    if (spinner) spinner.classList.toggle("hidden", !on);
  };

  const showError = (form, message) => {
    /* Dawn 이 이미 갖고 있는 오류 칸을 쓴다 — 새로 만들면 스타일이 갈린다. */
    const wrap = form.closest("product-form");
    const box = wrap && wrap.querySelector(".product-form__error-message-wrapper");
    const text = box && box.querySelector(".product-form__error-message");
    if (box && text) {
      text.textContent = message;
      box.removeAttribute("hidden");
      return;
    }
    window.alert(message);
  };

  document.addEventListener("click", (event) => {
    const btn = event.target.closest("[data-nt-buy-now]");
    if (!btn || btn.disabled) return;

    const form = document.getElementById(btn.getAttribute("data-form-id"));
    if (!form) return;

    event.preventDefault();

    /* ⚠️ 브라우저 기본 검사를 그대로 쓴다 — 필수 옵션·수량 범위를 여기서 다시 구현하면
       Add to Cart 와 판정이 갈린다. */
    if (typeof form.reportValidity === "function" && !form.reportValidity()) return;

    const body = new FormData(form);
    /* 응답을 작게 받는다(섹션 렌더링이 필요 없다). */
    body.delete("sections");
    body.delete("sections_url");

    setBusy(btn, true);

    fetch(ADD_URL, {
      method: "POST",
      headers: { Accept: "application/javascript" },
      body: body,
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data: data })))
      .then((result) => {
        if (!result.ok) {
          /* Shopify 는 재고 부족·옵션 미선택을 여기서 문장으로 돌려준다. */
          throw new Error(result.data.description || result.data.message || "");
        }
        /* ⚠️ `location.href` 로 이동한다(replace 아님) — 고객이 뒤로가기로 상품에 돌아올 수 있어야 한다. */
        window.location.href = CHECKOUT_URL;
      })
      .catch((err) => {
        setBusy(btn, false);
        showError(form, err.message || "Could not proceed to checkout. Please try again.");
      });
  });
})();
